import moment from 'moment'
import 'moment/locale/he'
import { IPersonalDetails } from 'types/interfaces/IPersonalDetails'

moment.locale('he')

const getHebrewMonthName = (monthNumber: number): string => {
  return moment()
    .month(monthNumber - 1)
    .format('MMMM')
}

const calculateAge = (dob: IPersonalDetails['dob']): number => {
  const birthDate = new Date(dob ? dob : new Date())
  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--
  }

  return age
}

export const dateService = { getHebrewMonthName, calculateAge }
